"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageVisibleInfoHelper = void 0;
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var document_renderer_1 = require("../../../../../canvas/renderes/common/document-renderer");
var PageVisibleInfoHelper = (function () {
    function PageVisibleInfoHelper() {
    }
    PageVisibleInfoHelper.showPageVisibleInfoElement = function (cache, getText, pageIndex) {
        PageVisibleInfoHelper.createAtLeast(pageIndex);
        var currElement = PageVisibleInfoHelper.pageVisibleInfoElements[pageIndex];
        currElement.innerHTML = getText();
        dom_1.DomUtils.hideNode(currElement);
        document_renderer_1.DocumentRenderer.getServiceContainerCore(cache[pageIndex].page).appendChild(currElement);
    };
    PageVisibleInfoHelper.hidePageVisibleInfoElement = function (pageIndex) {
        var element = PageVisibleInfoHelper.pageVisibleInfoElements[pageIndex];
        if (element) {
            PageVisibleInfoHelper.pageVisibleInfoElements.splice(pageIndex, 1);
            dom_1.DomUtils.hideNode(element);
        }
    };
    PageVisibleInfoHelper.createAtLeast = function (n) {
        while (PageVisibleInfoHelper.pageVisibleInfoElements.length <= n)
            PageVisibleInfoHelper.pageVisibleInfoElements.push(PageVisibleInfoHelper.createPageVisibleInfoElement());
    };
    PageVisibleInfoHelper.createPageVisibleInfoElement = function () {
        var element = document_renderer_1.DocumentRenderer.renderContainer("dxre-debug-page-visible-info-element");
        element.style.left = "5px";
        element.style.top = "5px";
        element.style.width = "150px";
        element.style.height = "50px";
        element.style.zIndex = "100";
        return element;
    };
    PageVisibleInfoHelper.pageVisibleInfoElements = [];
    return PageVisibleInfoHelper;
}());
exports.PageVisibleInfoHelper = PageVisibleInfoHelper;
